import * as DashboardInformationActions from './dashboard-information.actions';
import { DashboardInformation, StudentProfile } from './dashboard-information.model';




export class State {
  userInformation!: DashboardInformation  ;
}
let studentProfile1!: StudentProfile;
const initialState: State =  {
    userInformation : {
      studentProfile : studentProfile1,
    }
}

export function dashboardInformationReducer(state = initialState, action: DashboardInformationActions.DashboardInformationActions) {
  if (action.type === DashboardInformationActions.Add_DashboardInformation) {

      const updatedDashboardInformation = action.payload;

     let updatedDashboardInfo = updatedDashboardInformation;

      return {
        ...state,
        userInformation: updatedDashboardInfo
      };
  }
  else{
    return state;
  }
}

